import React from "react";
import { _teethOptions } from "../../helper";

const ToothBadge = ({ saved }) => {
  const option = _teethOptions.find((el) => el.value === saved.label);
  const badgeText = option?.badge;
  console.log("saved", saved?.color);
  if (!badgeText) return null;
  return (
    <span
      style={{
        background: saved.color || "#FFD700",
        color:
          saved?.color === "#FFFFFF"
            ? "#000000"
            : saved?.color === "#FFD700"
            ? "#000000"
            : saved?.color === "#00FF00"
            ? "#000000"
            : "#FFFFFF",
      }}
      className={`font-semibold text-[12px] rounded-[32px] px-2 py-[1.5px]`}
    >
      {badgeText}
    </span>
  );
};

export default ToothBadge;
